import React from "react";

function ModalNotifyTextAndButton2(props) {
    const { color, title,btnName1, btnName2, btnName3 } = props;
    return (<>
        <h4 style={{ color: color }}>{title}</h4>
        {/* <h4 style={{ color: color }}>Thay đổi của bạn sẽ tăng số hóa đơn, bạn vẫn muốn tiếp tục ?</h4> */}
        <div>---</div>
        <div >
             <button className={!btnName1? "op-hidden" : "btn btn-primary ml-2"}
                onClick={props.featureButton1}>{btnName1}</button>
            <button className={!btnName2? "op-hidden" : "btn btn-success ml-2"}
                //disabled={!isAddService}
                onClick={props.featureButton2} >{btnName2}</button>
            <button className={!btnName3? "op-hidden" : "btn btn-danger ml-2"}
                onClick={props.featureButton3} >{btnName3}</button>
        </div>
    </>)
}

export default ModalNotifyTextAndButton2;
